<template>
    <div>
        <van-nav-bar v-if="showNavBar" :title="title" left-text="返回" left-arrow @click-left="onClickBack"/>
        <router-view></router-view>
    </div>
</template>
<script>
    import {NavBar} from "vant";
    import userInfo from "../store/userInfo";

    export default {
        store: userInfo,
        components: {
            [NavBar.name]: NavBar
        },
        data() {
            return {}
        },
        methods: {
            onClickBack() {
                if(typeof uexWindow !== "undefined"){
                    uexWindow.evaluateScript("",'0', " goBack ()");
                } else {
                    this.$router.back(-2);
                }
            }
        },
        computed: {
            showNavBar() {
                return this.$store.getters.getShowNavBar;
            },
            title() {
                return this.$store.getters.title;
            }
        },
        watch: {
            '$route' (to, from) {
                this.$router.go(0);
            }
        }
    }
</script>
